import React from "react";
const summaryFields = [
  { key: "purpose", label: "Purpose of Assessment" },
  { key: "scope", label: "Scope" },
  { key: "strategy", label: "Strategy" },
  { key: "fireHistory", label: "Fire History" },
  { key: "lifeSafety", label: "Life Safety Concerns" },
  { key: "property", label: "Property Concerns" },
  { key: "business", label: "Business Continuity Concerns" },
  { key: "environmental", label: "Environmental Concerns" },
  { key: "conclusion", label: "Summary/Conclusion" }
];
export default function ExecutiveSummaryForm({ data, onChange }) {
  return (
    <fieldset className="fra-fieldset">
      <legend>Executive Summary</legend>
      {summaryFields.map(({ key, label }) => (
        <div className="fra-form-group" key={key}>
          <textarea
            value={data[key] || ""}
            onChange={e => onChange({ ...data, [key]: e.target.value })}
            placeholder={`Describe the ${label.toLowerCase()}...`}
            rows={2}
          />
          <label>{label}</label>
        </div>
      ))}
    </fieldset>
  );
}
